import React from 'react';
import { Input, DatePicker, TimePicker, Select, Switch, Form } from 'antd';
import { T, FIELD_HINT } from './declarationTheme';
import { fieldLabel, rulesAreRequired } from '../../../components/FieldLabel';
/* ─────────────────────────────────────────────────────────────
   Atomes de saisie stylés - utilisent AntD en dessous mais
   ré-habillés pour coller au design éditorial.

   Convention d'affichage (volontairement minimaliste) :
     • astérisque rouge sur les champs obligatoires - déduite des `rules` ;
     • aucune mention « · optionnel » : l'absence d'astérisque suffit ;
     • `hint` réservé à une information que ni le libellé ni le placeholder
       ne portent (conséquence métier / réglementaire). Sinon : rien.
   ───────────────────────────────────────────────────────────── */

const baseInputStyle = {
  height: 40,
  borderRadius: T.r.md,
  borderColor: T.line,
  fontSize: 14,
};

/* `optional` reste accepté pour compatibilité avec les anciens appels : il n'a
   plus d'effet visuel (l'absence d'astérisque suffit) et n'est pas transmis. */
export function Field({ name, label, hint, rules, required, optional, children, ...rest }) {
  const isRequired = required ?? rulesAreRequired(rules);
  return (
    <Form.Item
      name={name}
      label={fieldLabel(label, isRequired, { color: T.inkSoft })}
      rules={rules}
      extra={hint ? <span style={FIELD_HINT}>{hint}</span> : undefined}
      style={{ marginBottom: 20 }}
      {...rest}
    >
      {children}
    </Form.Item>
  );
}

export const inputProps = {
  style: baseInputStyle,
};

export const selectProps = {
  style: { ...baseInputStyle, height: 40 },
  popupMatchSelectWidth: true,
};

/* Grille 2 colonnes simple (responsive via min-width) */
export function Grid2({ children, gap = 20 }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap,
      }}
    >
      {children}
    </div>
  );
}

export function Grid3({ children, gap = 20 }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap,
      }}
    >
      {children}
    </div>
  );
}

export function Grid4({ children, gap = 16 }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap,
      }}
    >
      {children}
    </div>
  );
}

export { Input, DatePicker, TimePicker, Select, Switch };
